<template xmlns="http://www.w3.org/1999/html">
  <div class="main">
    <div id="background" style="height: 100%;
    width: 100vw;
    position:fixed;
    background: url(/static/images/bolang/bg_scanpage.png) no-repeat;
    background-attachment: fixed;
    background-size:cover;
    height: 100vh;
    overflow: hidden;top: 0; left: 0; right: 0; bottom: 0;display: flex;flex-direction: column;overflow-y: auto;">
      <img src="/static/images/bolang/logo.png" alt=""
        style="width: 30%;height: auto;position: absolute;top: 6%;right: 35%;">

      <div
        style="width:100%;position: absolute;top:73%;text-align: center;display: flex;flex-direction: column;justify-content: center;align-items: center;">
        <img src="/static/images/bolang/scan_jf_tip.png" alt="" style="width: 30%;height: auto;" />

        <div class="verification-container">
          <div class="verification-item" @click="openScan">
            <input class="verification-text" placeholder="扫码验证" readonly="true"></input>
            <button class="verification-button">
              <img src="/static/images/bolang/scan.png" />
            </button>
          </div>
          <div class="verification-item">
            <input v-model="antiCode" class="verification-text" placeholder="输入防伪码验证"  @input="handleInput"></input>
            <button class="verification-button" @click="toScan">查询</button>
          </div>
        </div>
      </div>





    </div>


  </div>
</template>

<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>


<style scoped>
body {
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}

.verification-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
  width: 70vw;
  align-items: center;
}

.verification-item {
  display: flex;
  align-items: center;
  border: 1px solid rgb(124, 136, 192);
  /* Border color */
  border-radius: 25px;
  overflow: hidden;
  width: 100%;
  /* Adjust width as needed */
  background-color: white;
}

.verification-text {
  padding: 10px 0px 10px 20px;
  font-size: 13px;
  color: rgb(145, 151, 164);
  border: 0px;
  /* Text color */
  text-align: left;
  width: 70%;
}

.verification-button {
  background: linear-gradient(to bottom, rgb(81, 91, 167), rgb(52, 60, 125), rgb(81, 91, 167));
  /* Gradient colors */
  /* Button background color */
  color: white;
  width: 30%;
  border: none;
  padding: 8px 20px;
  margin-right: 1px;
  font-size: 0.8rem;
  cursor: pointer;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  /* Optional shadow for depth */
}

.verification-button img {
  width: 18px;
  /* Adjust icon size */
  height: 18px;
}
</style>

<script>
import { getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      antiCode: ""
    }
  },
  methods: {
    handleInput(){
      this.antiCode = this.antiCode.replace(/(\w{4})(?=\w)/g, '$1 ');
    },
    openScan() {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('/');
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : ''
            scanQRCode = scanQRCode.substring(0, 16)
          }
          this.$router.replace({
            path: '/bolang/result',
            query: {
              c: scanQRCode,
              eno: this.eno
            }
          })
        }
      });
    },
    toScan() {
      if (this.antiCode == "") {
        alert("请输入16位防伪码进行查询");
        return;
      }
      const code = this.antiCode.replace(/\s+/g, '');
      this.$router.replace({
        path: '/bolang/result',
        query: {
          c: code,
          eno: this.eno
        }
      })
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wxc0571471f3bb3b8d").then(res => {
        console.log(res)
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  mounted() {
    const handleFontSize = () => {
      // 设置网页字体为默认大小
      WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
      // 重写设置网页字体大小的事件
      WeixinJSBridge.on('menu:setfont', function () {
        WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 });
      });
    };
    try {
      // 安卓 禁止用户自定义设置字体大小
      if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
        handleFontSize();
      } else {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', handleFontSize, false);
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', handleFontSize);
          document.attachEvent('onWeixinJSBridgeReady', handleFontSize);
        }
      }
    } catch (error) { }

  },
  created: function () {
    this.getWxJs()
    const params = this.$route.query;
    this.eno = params.eno;
    if (this.eno == "" || this.eno == undefined) {
      alert("请使用正确入口地址进行查询")
    }
  }
}

</script>


// WEBPACK FOOTER //
// src/components/BoLangFeiLin/Scan.vue